import { useMemo, useState } from "react";
import { eventList, eventCategories, type EventItem } from "@/mocks/chigua";

export default function EventSection() {
  const [category, setCategory] = useState("全部");
  const list = useMemo<EventItem[]>(
    () => (category === "全部" ? eventList : eventList.filter((e) => e.category === category)),
    [category],
  );

  return (
    <section id="events" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-newspaper-line" aria-hidden="true"></i>
              吃瓜入口索引
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">最新事件 · 先睹为快</h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              吃瓜入口索引收录近期全网热议的最新事件，分类清楚、要点分明，帮你快速补齐前情并找到后续讨论入口。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 lg:max-w-xl lg:justify-end">
            {eventCategories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setCategory(c)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${category === c ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600 ring-1 ring-background-200 hover:bg-primary-50 hover:text-primary-700"}`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((ev) => (
            <article key={ev.id} className="group animate-pop overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-soft">
              <div className="relative h-40 w-full overflow-hidden">
                <img src={ev.image} alt={ev.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <span className="absolute left-3 top-3 inline-flex whitespace-nowrap rounded-full bg-background-50/90 px-2 py-0.5 text-xs font-medium text-foreground-800">
                  {ev.tag}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500/90 px-2 py-0.5 text-xs text-background-50">
                  <i className="ri-fire-fill" aria-hidden="true"></i>
                  {ev.hot}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold leading-snug text-foreground-950 md:text-base">{ev.title}</h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500 md:text-sm">{ev.summary}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {ev.time}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-primary-600 transition-colors group-hover:text-primary-700">
                    前往围观
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}